// extracted by mini-css-extract-plugin
export var main = "layout-module--main--1XJsu";
export var footer = "layout-module--footer--3iD_9";